import styled from '@emotion/styled'
import type { TypographyProps } from '@polycups/react'

import { BodyM } from '@/components/Typography'
import { VisuallyHidden } from '@/components/VisuallyHidden'

export interface AccessibleHighlightedTextProps extends TypographyProps {
  text: string
  highlightedText?: string
  accessibleText: string
  classNames?: string
}

const ScreenReaderHiddenStyled = styled(BodyM)`
  display: flex;
  justify-content: center;
  align-items: center;
`

const HighlightedLabel = styled(BodyM)`
  margin: 0 0.25rem;
`

const AccessibleHighlightedText = ({
  text,
  highlightedText,
  accessibleText,
  ...props
}: AccessibleHighlightedTextProps) => (
  <>
    <ScreenReaderHiddenStyled tag="span" color="dark-medium" aria-hidden {...props}>
      {text}
      <HighlightedLabel tag="p" emphasys>
        {highlightedText}
      </HighlightedLabel>
    </ScreenReaderHiddenStyled>
    <VisuallyHidden as="p">{accessibleText}</VisuallyHidden>
  </>
)

export default AccessibleHighlightedText
